import styled from 'styled-components';

export const ImageStyled = styled.img`
  max-width: 4rem;
  max-height: 4rem;
`;
